export default __webpack_public_path__ + "QuickSuite-logo-default.b09eadde.svg";